const FormWidgetSpaceConfig = {
  componentType: 'FORM_WIDGET_SPACE',
  widgetConfig: {
    icon: 'form-space',
    text: '占位符',
    description: '适用于根据不同场景优化布局'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6,
    height: 1,
    render: {
      ide: 'FormWidgetSpace',
      edit: 'FormWidgetSpace',
      read: 'FormWidgetSpace'
    }
  },
  editorConfig: ['INFO', 'WIDTH']
}

export default FormWidgetSpaceConfig
